import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SplashScreenComponent } from "./components/splash-screen/splash-screen.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { LightgalleryModule } from "lightgallery/angular";
import { WindowService } from "../core/services/window.service";
import { authInterceptorProviders } from "../core/interceptor/auth.interceptor";
import { AuthService } from "../core/services/auth.service";
import { errorInterceptorProviders } from "../core/interceptor/error.interceptor";
import { GridGalleryItemComponent } from "./components/grid-gallery/grid-gallery-item/grid-gallery-item.component";
import { GridGalleryComponent } from "./components/grid-gallery/grid-gallery.component";
// NgbModule removed: nothing in the app used it - no ngb* directives, no <ngb-*>
// elements, no Ngb* services injected anywhere. SharedModule is eagerly loaded by
// AppModule, so this was ~500KB of ng-bootstrap sitting in vendor.js for nothing.
import { AlbumTabsComponent } from "./components/album-tabs/album-tabs.component";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { MatToolbarModule } from "@angular/material/toolbar";
import { EventGalleryComponent } from "../event-gallery/event-gallery.component";
import { EventGalleryV2Component } from "../event-gallery/event-gallery-v2.component";
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { EventSettingsComponent } from "../event-settings/event-settings.component";
import { MatChipsModule } from '@angular/material/chips';
import { ClipboardModule } from "@angular/cdk/clipboard";
import { ConfirmationModalComponent } from "./confirmation-modal/confirmation-modal.component";
import { ShareModalComponent } from "../share-popup/share-popup.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { IconComponent } from "./icon/icon.component";
import { LoginPopupComponent } from "../login-popup/login-popup.component";
import { StorageUpgradeBannerComponent } from "../storage-upgrade-banner/storage-upgrade-banner.component";
import { GuestbookFormComponent } from "../event-detail/guestbook-form/guestbook-form.component";
import { DemoTourComponent } from "../demo-tour/demo-tour.component";
import { AccountStatusBannerComponent } from "../account-status-banner/account-status-banner.component";
import { GuestPhotoWallComponent } from "../guest-photo-wall/guest-photo-wall.component";
import { GuestHostSheetComponent } from "../guest-host-sheet/guest-host-sheet.component";
import { InviteShareComponent } from "../invite-share/invite-share.component";
import { CardUnitDirective } from "../invite-share/card-unit.directive";
import { CreateEventFormComponent } from "../create-event-form/create-event-form.component";
import { PickerSheetComponent } from "../create-event-form/picker-sheet/picker-sheet.component";
import { CategorySheetComponent } from "../create-event-form/category-sheet/category-sheet.component";
import { StartSheetComponent } from "../create-event-form/start-sheet/start-sheet.component";
import { DurationSheetComponent } from "../create-event-form/duration-sheet/duration-sheet.component";
import { VoicePanelComponent } from "../create-event-form/voice/voice-panel.component";
import { VoiceChatComponent } from "../create-event-form/voice/voice-chat.component";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { A11yModule } from "@angular/cdk/a11y";
import { EventBrandingComponent } from "../event-branding/event-branding.component";
import { AddBrandingComponent } from "../add-branding/add-branding.component";

@NgModule({
  declarations: [
    SplashScreenComponent,
    GridGalleryComponent,
    GridGalleryItemComponent,
    AlbumTabsComponent,
    EventGalleryComponent,
    EventGalleryV2Component,
    ConfirmationModalComponent,
    IconComponent,
    LoginPopupComponent,
    StorageUpgradeBannerComponent,
    GuestbookFormComponent,
    DemoTourComponent,
    AccountStatusBannerComponent,
    GuestPhotoWallComponent,
    GuestHostSheetComponent,
    InviteShareComponent,
    CardUnitDirective,
    CreateEventFormComponent,
    // Create form v2 (docs/CREATE_EVENT_VOICE_PLAN.md) — only CreateEventFormComponent uses these.
    PickerSheetComponent,
    CategorySheetComponent,
    StartSheetComponent,
    DurationSheetComponent,
    VoicePanelComponent,
    VoiceChatComponent,
    EventBrandingComponent,
    AddBrandingComponent,
    //EventSettingsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatExpansionModule,
    FormsModule,
    HttpClientModule,
    LightgalleryModule,
    ClipboardModule,
    MatCardModule,
    MatChipsModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatTabsModule,
    MatGridListModule,
    MatDialogModule, MatAutocompleteModule,
    MatToolbarModule,
    NgxSkeletonLoaderModule,
    MatSidenavModule,
    MatListModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    OverlayModule,
    PortalModule,
    A11yModule
  ],
  exports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    SplashScreenComponent,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule, MatExpansionModule,
    LightgalleryModule,
    MatCardModule,
    MatSelectModule,
    MatSnackBarModule,
    GridGalleryComponent,
    GridGalleryItemComponent,
    MatGridListModule,
    AlbumTabsComponent,
    EventGalleryComponent,
    EventGalleryV2Component,
    MatDialogModule,
    MatSidenavModule,
    MatListModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    MatInputModule,
    MatTooltipModule,
    MatAutocompleteModule,
    NgxSkeletonLoaderModule,
    ClipboardModule,
    ConfirmationModalComponent,
    IconComponent,
    LoginPopupComponent,
    StorageUpgradeBannerComponent,
    GuestbookFormComponent,
    DemoTourComponent,
    AccountStatusBannerComponent,
    GuestPhotoWallComponent,
    GuestHostSheetComponent,
    InviteShareComponent,
    CreateEventFormComponent,
    EventBrandingComponent,
    AddBrandingComponent
  ],
  providers: [

    WindowService,
    authInterceptorProviders,
    //  errorInterceptorProviders,
    AuthService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }]

})
export class SharedModule { }
